<template>
    <div v-if="dotsLoading" class="mt-2">
		<!-- <div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white"> -->
			<dots-loader/>
		<!-- </div> -->
    </div>
    <div :class="modalMode ? 'details-in-modal task-details-in-modal finding-details-in-modal' : 'mb-5 mx-5 mt-3'" v-else>
        <div class="mb-1" v-if="!modalMode">
			<breadCrumbs :routesArray="routesArray"></breadCrumbs>
		</div>
        <div>
            <div class="flex flex-row justify-between">
                <div class="items-center justify-between flex" v-if="!modalMode">
                    <div class="title flex items-center">
                        <h1>{{ presentFindingObject.findingComment!=undefined?presentFindingObject.findingComment:'N/A' }}</h1>
                    </div>
                </div>
                <div v-else></div>
                <div class="flex flex-row" v-if="approvalObj.statusCode == 10401 && checkAuditor(presentFindingObject.auditor)">
                    <button class="btnprimary items-center btnPrimaryPadding mr-2" :disabled="clickOnButtonForRejectingApproval" @click="approveOrReject(10403)">Approve</button>
                    <button class="btnprimary items-center btnPrimaryPadding" @click="showPopupToReject()">Reject</button>
                </div>
            </div>
            <!-- <div class="mt-3">
                <p class="headerText">
                    An IT audit or information technology audit is an investigation and evaluation of IT systems, infrastructures, policies, and operations. Through IT audits, a company can determine if the messing T controls protect corporate assets, ensure data integrity and align with the organization's business and financial controls.
                </p>
            </div> -->
      </div>

        <div class="w-full minheight">
			<div class="w-full">
				<div class="text-sm">
                    <div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
                        <div class="w-80 heightFixing pr-5">
                        <!-- <div class="tabStructureDiv">
                                    <div class="flex flex-row borderBottom justify-between cursor-pointer tab-container">
                                <div class="pb-1 " :class="selectedTabIndex == tab.id ? 'adjust header font-semibold text-primary':'text-sm text-disabledgrey'" v-for="(tab, tabIndex) in tabHead" :key="tabIndex" @click="toggleTabs(tab)">
                                    <div>
                                        <div class="cursor-pointer">{{ tab.displayName }}</div>
                                        <div :class="{ progress: selectedTabIndex == tab.id }" class="h-1 p-0.75"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="progressbarB rounded h-1"></div>
                        </div> -->
                        <Tabs  v-model:value="selectedTabIndex" scrollable class="heightFixing">
								<div>
									<TabList>
										<Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
											{{ tab.displayName }}
										</Tab>
									</TabList>
								</div>
								<TabPanels class="overflow-auto hide-scrollbar">
									<TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
                                        <div v-if="tabDataLoading == true">
											<div class="flex items-center justify-center w-full h-16 skeleton">
											<dots-loader/>
											</div>
										</div>
                                        <div v-else class="h-full">
                                                <div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1">
                                                    <div>
                                                        <div class="border-b border-lightgrey flex justify-between mb-5 paddingBottomForFindings mt-3">
                                                            <div class="marginBottom1px flex items-center justify-center">
                                                                <div>
                                                                    <p class="header mt-0.5">Finding Information</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                <div>
                                                    <!-- <div v-for="(obj, index) in presentFindingObject" :key="index" class="mt-3">{{ obj }} -->
                                                    <div class="flex flex-row">
                                                        <div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">Finding ID</div>
                                                        <div  class="border header border-lightgrey w-77 p-2 rounded-tr-md text-xs">
                                                            {{presentFindingObject.findingId}}
                                                        </div>
                                                    </div>
                                                    <div class="w-full flex flex-row">
                                                        <div class="border-l w-23 border-b p-2 header border-lightgrey">Framework</div>
                                                        <div  class="w-27 border-b border-l border-lightgrey text-xs p-2">
                                                            <div class="mt-1">{{presentFindingObject.frameworks}}</div>
                                                        </div>
                                                        <div class="border-l w-23 border-b p-2 header border-lightgrey">Control Number</div>
                                                        <div  class="border-r w-27 border-b border-l border-lightgrey p-2">
                                                            <div class="pl-3 flex items-center flex-wrap">
                                                                <div :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center" >
                                                                    {{presentFindingObject.frameWorkControl}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="flex flex-row">
                                                        <div class="border-l border-b p-2 header w-23 border-lightgrey">Control Title</div>
                                                        <div class="border-r border-b border-l border-lightgrey w-77 text-xs p-2">{{ presentFindingObject.frameworkControlTitle ? presentFindingObject.frameworkControlTitle : 'N/A' }}</div>
                                                    </div>
                                                    <div class="flex flex-row">
                                                        <div class="border-l border-b p-2 header w-23 border-lightgrey">Finding</div> 
                                                    <div  class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify">{{presentFindingObject.findingComment}}</div>
                                                    </div>
                                                    <div class="flex flex-row">
                                                        <div class="border-l border-b p-2 header w-23 border-lightgrey">Finding Severity</div>
                                                        <div class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center">
                                                            <div
                                                                v-if="getFindingSeverityValue(presentFindingObject) != null"
                                                                class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden"
                                                                :class="findingSeverityChipBg(presentFindingObject)"
                                                                :title="getFindingSeverityLabel(presentFindingObject)"
                                                            >
                                                                <div class="truncate whitespace-nowrap" :class="findingSeverityChipText(presentFindingObject)">
                                                                    {{ getFindingSeverityLabel(presentFindingObject) }}
                                                                </div>
                                                            </div>
                                                            <span v-else>N/A</span>
                                                        </div>
                                                    </div>
                                                    <div class="flex flex-row">
                                                        <div
                                                            class="border-l border-b p-2 header w-23 border-lightgrey flex items-center"
                                                        >
                                                            Evidence
                                                        </div>
                                                        <div
                                                            class="border-r border-b border-l border-lightgrey w-77 min-w-0 text-xs p-2 text-justify rounded-br-md"
                                                        >
                                                            <div v-if="findingFileEvidences.length || findingLinkEvidences.length" class="flex gap-3 flex-wrap">
                                                            <div v-for="(doc, idx) in findingFileEvidences" :key="'finding-file-'+idx">
                                                                <div class="pdf w-full rounded-sm">
                                                                    <a
                                                                        href="#"
                                                                        @click.prevent="openEvidenceFile(doc)"
                                                                        class="flex w-full flex-row items-center cursor-pointer"
                                                                    >
                                                                        <img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
                                                                        <img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
                                                                        <img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
                                                                        <img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
                                                                        <img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
                                                                        <img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
                                                                        <img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
                                                                        <img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
                                                                        <img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
                                                                        <img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
                                                                        <img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
                                                                        <img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
                                                                        <img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
                                                                        <div class="flex flex-col w-full min-w-0">
                                                                            <div class="ml-2 pb-1">
                                                                            <p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
                                                                            </div>
                                                                            <div class="flex justify-between w-full">
                                                                            <p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
                                                                            <p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div v-for="(doc, idx) in findingLinkEvidences" :key="'finding-link-'+idx">
                                                                <div class="pdf w-full rounded-sm">
                                                                    <a
                                                                        href="#"
                                                                        @click.prevent="openEvidenceFile(doc)"
                                                                        class="flex w-full flex-row items-center cursor-pointer finding-evidence-link-icon"
                                                                        :aria-label="doc.url"
                                                                    >
                                                                        <span class="finding-evidence-link-icon__img-wrap">
                                                                            <img src="@/assets/link.svg" alt="Link" class="finding-evidence-link-icon__img" />
                                                                            <span class="finding-evidence-link-icon__tooltip">{{ doc.url }}</span>
                                                                        </span>
                                                                        <div class="flex flex-col w-full min-w-0">
                                                                            <div class="ml-2 pb-1">
                                                                                <p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
                                                                            </div>
                                                                            <div class="flex justify-between w-full">
                                                                                <p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
                                                                                <p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div v-else>{{ presentFindingObject.findingEvidence }}</div>
                                                        </div>
                                                        
                                                        </div>
                                                    <div class="w-full flex flex-row">
                                                        <div class="border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md">Finding Category</div>
                                                        <div  class="w-27 border-b border-l border-lightgrey  p-2">
                                                                <div v-if="presentFindingObject.findingCategory === 1" class="flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold">{{getCategory(presentFindingObject.findingCategory)}}</div>
                                                                <div v-if="presentFindingObject.findingCategory === 2" class="flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold">{{getCategory(presentFindingObject.findingCategory)}}</div>
                                                                <div v-if="presentFindingObject.findingCategory === 3" class="flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold">{{getCategory(presentFindingObject.findingCategory)}}</div>
                                                                <div v-if="presentFindingObject.findingCategory === 4" class="flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold">{{getCategory(presentFindingObject.findingCategory)}}</div>
                                                            </div>
                                                            <div class="border-l w-23 border-b p-2 header border-lightgrey">Control Audit Result</div>
                                                            <div class="border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md">
                                                                <div v-if="presentFindingObject.auditResult === 'Pass'" class="flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid text-xs border border-lightgreen font-semibold">{{presentFindingObject.auditResult}}</div>
                                                                <div v-if="presentFindingObject.auditResult === 'Fail'" class="flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid text-xs border border-darkred font-semibold">{{presentFindingObject.auditResult}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                <div>
                        <div>
                          <div class="border-b border-lightgrey">
                              <p class="mt-4 mb-1.5 header">Control Information</p>
                          </div>
                        </div>
                    <div class="flex">
                      <div class="w-6/12">
                        <p class="font-extrabold mt-2.5 mb-1 text-xs">CID</p>
                        <p class="mt-1 mb-3 text-sm" v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.clientUniqueId!=undefined">{{ presentFindingObject.controlInfo!=undefined&&presentFindingObject.controlInfo[0]?.clientUniqueId!='' ? presentFindingObject.controlInfo[0]?.clientUniqueId : 'N/A'}}</p>
                        <p v-else class="mt-1 mb-2 text-sm">N/A</p>
                      </div>
                      <div class="w-6/12">
                        <p class="font-extrabold mt-2.5 mb-1 text-xs">Frequency</p>
                        <p v-if="presentFindingObject && presentFindingObject !=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo[0]?.controlFrequency!=undefined" class="mt-1 mb-3 text-sm">{{dbFrequency.find((l) => l.value == presentFindingObject.controlInfo[0]?.controlFrequency)?.key}}</p>
                        <p class="text-sm mt-1 mb-3" v-else>N/A</p>
                      </div>
                      
                    </div>
                    </div>
                    <div class="flex">
                        <div class="w-6/12">
                            <p class="font-extrabold mb-1 text-xs">Title</p>
                            <p class="mt-1 mb-3 text-sm" v-if="presentFindingObject && presentFindingObject !=undefined && presentFindingObject.controlInfo &&presentFindingObject.controlInfo.length>0 && presentFindingObject.controlInfo[0]?.controlTitle!=undefined ">{{presentFindingObject.controlInfo[0].controlTitle }}</p>
                            <p class="mt-1 mb-3 text-sm" v-else>N/A</p>
                        </div>
                        <div class="w-6/12">
                          <p class="font-extrabold mb-1 text-xs">Type</p>
                            <p class="mt-1 mb-3 text-sm"
                                v-if="presentFindingObject?.controlInfo?.length > 0 && presentFindingObject.controlInfo[0]?.controlType"
                                >
                                {{ presentFindingObject.controlInfo[0].controlType || 'N/A' }}
                            </p>
                            <p class="mt-1 mb-3 text-sm" v-else>N/A</p>
                        </div>
                    </div>
                  
                    <div class="flex">
                      <div class="w-6/12">
                        <p class="font-extrabold mb-1 text-xs">Class</p>
                        <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlClass!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0].controlClass||'N/A' }}</p>
                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                      </div>
                      <div class="w-6/12">
                        <p class="font-extrabold mb-1 text-xs">Family</p>
                        <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlFamily!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0].controlFamily||'N/A' }}</p>
                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                      </div>

                    </div>
                    <div class="flex flex-row"> 
                      <div class="w-6/12">
                        <label class="font-extrabold text-xs">Priority</label>
                        <div v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlPriority!=undefined && typeof presentFindingObject.controlInfo[0]?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentFindingObject.controlInfo[0]?.controlPriority)">
                          <div class="text-xs" :class="colorLabelText(presentFindingObject.controlInfo[0]?.controlPriority)">
                          {{ getProirityLabel(presentFindingObject.controlInfo[0]?.controlPriority) }}
                          </div>
                        </div>
                        <div v-else class="text-sm mt-1 mb-3">N/A</div>
                      </div>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 text-xs">Description</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.Description!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0]?.Description||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlPolicies!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0].controlPolicies||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div>
                      <label class="font-extrabold mt-2 mb-1 text-xs">Guidance</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlGuidance!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0].controlGuidance||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.controlInfo && presentFindingObject.controlInfo.length>0&& presentFindingObject.controlInfo[0]?.controlMaintenanceTask!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.controlInfo[0].controlMaintenanceTask||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                                            </div>
                                                <div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
                                                    
                                                    <div>
                                                        <div class="border-b border-lightgrey flex justify-between paddingBottomforApproval mb-5 mt-3">
                                                            <div class="flex items-center justify-center">
                                                                <div>
                                                                    <p class="header">Cause & Action</p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="buttonposition flex justify-center items-center">
                                                                    <div class="buttonposition flex justify-center items-center">
                                                                        <button :class="(presentFindingObject.auditee != userInfo._id && newTeamAssignee.value != userInfo._id && this.userInfo.organisationType!=10701) || TaskDetailsDropDown.findingStatus == 10418 || approvalObj.statusCode == 10422 || presentFindingObject.auditor == userInfo._id || presentFindingObject.statusCode == 10421  || !isAddDisabled(10302) ? 'btndisabled pointer-events-none' : 'filterButton'" @click="openCausePopup()">
                                                                            Add Cause
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                        <div v-if="presentFindingObject.causes != undefined  && presentFindingObject.tasks == undefined">
                                                            <div v-for="(cause, number) in presentFindingObject.causes" class="mb-3" :key="number" >
                                                                <div class="border border-lightgrey bg-moderategrey">
                                                                    <div class="w-full flex flex-row">
                                                                        <div class="w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center">Cause for this Finding </div>
                                                                                <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ presentFindingObject.causes[number].cause}}</div>
                                                                        <div class="w-15 flex items-center justify-center">
                                                                            <div class="flex justify-around w-full">
                                                                                <img src="@/assets/editdefault.svg" class="cursor-pointer" :class="TaskDetailsDropDown.findingStatus == 10421 ? 'hidden' : '' " @click="editCauseAndAction(cause)" />
                                                                                <img src="@/assets/deleteIcon.svg" class="cursor-pointer" :class="TaskDetailsDropDown.findingStatus == 10421 ? 'hidden' : '' " @click="deleteCauseAndAction(cause.causeId, cause.cause)" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> 
                                                                <ul>
                                                                    <li v-for="(action, index) in cause.actions" :key="index">
                                                                        <div class="border border-lightgrey">
                                                                            <div class="w-full flex flex-row">
                                                                                <div class="w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center">Action{{ index + 1 }} for this Finding </div>
                                                                                        <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ action.action }}</div>
                                                                                <div class="w-15 p-3 flex flex-row items-center justify-center">
                                                                                    <!-- <img src="@/assets/link.svg" class="mr-3 cursor-pointer"/> -->
                                                                                    <!-- <img src="@/assets/deleteIcon.svg" class="cursor-pointer"/> -->
                                                                                    <div class="flex items-center justify-center rounded h-5 w-24 bg-lightgrey border-solid border border-disabledgrey">
                                                                                        <div class="font-semibold text-xs text-disabledgrey">
                                                                                            Not Started
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                    </div>
                                                                        
                                                                        </li>
                                                                </ul> 
                                                            </div>
                                                        </div>
                                                        <div v-else-if="presentFindingObject.tasks != undefined">
                                                            <div v-for="(task, number) in finalFindingsTasks" class="mb-3" :key="number" >
                                                                <div class="border border-lightgrey bg-moderategrey">
                                                                    <div class="w-full flex flex-row">
                                                                        <div class="w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center">Cause for this Finding </div>
                                                                                <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ number }}</div>
                                                                    <div class="w-15 flex items-center justify-center p-3">
                                                                        <div class="flex items-center justify-center rounded h-5 w-24 evidenceUpload border-solid border border-primary">
                                                                            <div class="font-semibold text-xs text-primary">
                                                                                Approved
                                                                            </div>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-for="(task1, num) in task" :key="num">
                                                                <ul>
                                                                    <li>
                                                                        <div class="border-b border-x border-lightgrey">
                                                                            <div class="w-full flex flex-row">
                                                                                <div class="w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center">Action{{ num + 1 }} for this Finding</div>
                                                                                        <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify cursor-pointer" @click="goToActionTasks(task1._id)">{{ task1.action }}</div>
                                                                                <div class="w-15 p-3 flex flex-row items-center justify-center">
                                                                                    <div class="flex items-center justify-center rounded h-5 w-24" :class="colorFindingBg(task1.statusCode)">
                                                                                            <div class="text-xs" :class="colorFindingText(task1.statusCode)">
                                                                                                {{ getStatusLabel(task1.statusCode) }}
                                                                                            </div>
                                                                                        </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>  
                                                                    </li>
                                                                </ul>
                                                                </div>
                                                                
                                                            

                                                            </div>
                                                        </div>
                                        <!-- </div> -->
                                            </div>
                                                <div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 3">
                                                    <div>
                                                        <div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
                                                                <div class="flex items-center justify-center">
                                                                    <div>
                                                                        <p class="header">Comments</p>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div class="buttonposition flex justify-center items-center">
                                                                        <div class="buttonposition flex justify-center items-center">
                                                                            <button class="filterButton w-24 flex" v-if="oldComments" @click="sortComments()">
                                                                                <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                                                                Oldest
                                                                            </button>
                                                                            <button class="filterButton w-24 flex" v-if="!oldComments" @click="sortComments()">
                                                                                <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                                                                Newest
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        <div>
                                                            <div class="comment-box w-full mt-5">
                                                                <!-- <div class="my-3"><textarea placeholder="Add a Comment" class="w-full text-xs border border-lightgrey rounded-sm p-2" rows="4" v-model="comment" :disabled="approvalObj.statusCode == 10403" @input="handleInput"></textarea></div>
                                                                <div class="flex justify-end">
                                                                    <button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
                                                                    <button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Clear</button>
                                                                </div> -->
                                                                <commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10422  && TaskDetailsDropDown.taskStatus!=10418 && TaskDetailsDropDown.taskStatus!=10417 && isAddDisabled(10302)" :taskStatusCode="TaskDetailsDropDown.taskStatus"/>
                                                            </div>
                                                        <!-- dfghjkl {{ presentFindingObject[0].comments }} -->
                                                            <div class="comments">
                                                                <!-- <div v-for="(obj, index) in presentFindingObject" :key="index"> -->
                                                                    <div v-for="(comment, number) in presentFindingObject.comments" :key="number"  class="border border-lightgrey mt-2 rounded-sm flex flex-row p-3">
                                                                        <div class="initials">{{extractInitials((comment.name) )}}</div>
                                                                        <div class="w-1/5">
                                                                                    <div class="header">{{comment.name}}</div>
                                                                                    <div class="fontSize10PX">{{ presentFindingObject.createdAt }}</div>
                                                                        </div>
                                                                        <div class="w-4/5 text-xs text-justify" >
                                                                        <safeHtml :content="comment.comment"/></div>
                                                                    </div>
                                                                    <!-- </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
                                                    <div>
                                                        <div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
                                                            <div class="flex items-center justify-center">
                                                                <div>
                                                                    <p class="header">WorkLog</p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="buttonposition flex justify-center items-center">
                                                                    <div class="buttonposition flex justify-center items-center">
                                                                        <button class="filterButton w-24 flex " v-if="oldHistory" @click="sortHistory()">
                                                                            <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                                                            Oldest
                                                                        </button>
                                                                        <button class="filterButton w-24 flex " v-if="!oldHistory" @click="sortHistory()">
                                                                            <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                                                            Newest
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                </div>
                                                                <div v-for="work in workLogObject.findingHistory" :key="work" class="bg-white py-4 pl-4 mb-0.5 border-lightgrey border-b w-full">
                                                                    <!-- {{ work.additionalInfo }} -->
                                                                    
                                                                    <div class="flex">
                                                                        <div v-if="Object.keys(work).includes('createdBy')" class="initials">
                                                                            {{ extractInitials(work.name) }}
                                                                        </div>
                                                                        <div v-if="Object.keys(work).includes('updatedBy')" class="initials">
                                                                            {{ extractInitials(work.name) }}
                                                                        </div>
                                                                        <div class="logContainer w-93">
                                                                            <div class="flex mt-1">
                                                                                <p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
                                                                                    {{ work.name }}
                                                                                </p>
                                                                                <p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
                                                                                    {{work.name }}
                                                                                </p>

                                                                                <p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Finding on' }}</p>
                                                                                <p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Finding on' }}</p>
                                                                                <p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Finding on' }}</p>

                                                                                <p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
                                                                                <p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
                                                                            </div>
                                                                            
                                                                            <div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
                                                                                <div v-if="work.additionalInfo.comment" class="flex">
                                                                                    <div class="font-semibold text-xs widthForCommentBox">Comment :</div>
                                                                                    <div class="text-xs w-full text-justify">
                                                                                        <safeHtml :content="work.additionalInfo.comment"></safeHtml>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-if="work.additionalInfo.cause" class="flex flex-row">
                                                                                    <div v-if="work.additionalInfo.action == 10301" class="font-semibold text-xs w-18">Created the Cause :</div>
                                                                                    <div v-else-if="work.additionalInfo.action == 10302" class="font-semibold text-xs w-18">Updated the Cause :</div>
                                                                                    <div v-else-if="work.additionalInfo.action == 10303" class="font-semibold text-xs w-18">Deleted the Cause :</div>
                                                                                    <div class="text-xs w-82 text-justify">{{ work.additionalInfo.cause}}</div>
                                                                                </div>
                                                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
                                                                                    <p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
                                                                                    <p class="mx-2 text-xs text-justify">{{ getPersonName(work.additionalInfo.assignee) }}</p>
                                                                                </div>
                                                                                
                                                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
                                                                                    <p class="font-semibold text-xs">{{'Sent Approval for -'}}</p>
                                                                                    <p class="mx-2 text-xs text-justify">{{ getPersonName(work.additionalInfo.approver) }}</p>
                                                                                </div>
                                                                                <div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10410">
                                                                                    <p class="font-semibold text-xs text-justify">{{'Approval is Rejected - '}}</p>
                                                                                    <p class="mx-2 text-xs text-justify">{{ work.additionalInfo.justification||'N/A' }}</p>
                                                                                </div>
                                                                                <div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10422">
                                                                                    <p class="font-semibold text-xs text-justify">{{'Approval is Accepted'}}</p>
                                                                                </div>
                                                                                <div v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
                                                                                    <div class="flex items-center">
                                                                                        <div>
                                                                                            <p class="font-semibold text-xs text-justify">{{'Updated The Status :'}}</p>
                                                                                        </div>
                                                                                        <div class="flex ml-4">
                                                                                        <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.previousStatus)">
                                                                                            <div class="text-xs" :class="colorFindingText(work.additionalInfo.previousStatus)">
                                                                                                {{ getStatusLabel(work.additionalInfo.previousStatus) }}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
                                                                                        <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.updatedStatus)">
                                                                                            <div class="text-xs" :class="colorFindingText(work.additionalInfo.updatedStatus)">
                                                                                                {{ getStatusLabel(work.additionalInfo.updatedStatus) }}
                                                                                            </div>
                                                                                            </div>
                                                                                    </div>
                                                                                    </div>
                                                                                    <div
                                                                                        v-if="(work.additionalInfo.previousStatus == 10406 || work.additionalInfo.previousStatus == 10402) && (work.additionalInfo.updatedStatus == 10406 || work.additionalInfo.updatedStatus==10422) && work.additionalInfo.taskId"
                                                                                        class="mt-1 text-xs"
                                                                                    >
                                                                                        ID:<span class="font-semibold ml-1">{{ work.additionalInfo.taskId }}</span> is completed
                                                                                    </div>
                                                                                    </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                    </div>

                                                </div>
                                                <div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 4">
                                                    <div>
                                                        <div class="border-b border-lightgrey flex justify-between paddingBottomforApproval mt-3">
                                                            <div class="flex items-center justify-center">
                                                                <div>
                                                                    <p class="header">Approvals</p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="buttonposition flex justify-center items-center"> 

                                                                    <button class="flex" :class="(presentFindingObject.auditee != userInfo._id && newTeamAssignee.value != userInfo._id && this.userInfo.organisationType!=10701) || causesLength == true || approvalObj.statusCode == 10401 || approvalObj.statusCode == 10422 || presentFindingObject.auditor == userInfo._id  ? 'btndisabled pointer-events-none' : 'filterButton'" @click="openApprovalpopup()">
                                                                        Send Approval 
                                                                    </button>    

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div v-for="(approval, number) in presentFindingObject.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
                                                                <div v-if="approval.createdBy != undefined" class="initials">{{extractInitials((approval.name))}}</div>
                                                                <div v-if="approval.createdBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>
                                                                
                                                                <div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials((approval.name))}}</div>
                                                                <div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>

                                                                <div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
                                                                <div v-else-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
                                                                <div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>

                                                                <div v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.createdAt)}}</div>
                                                                <div v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.updatedAt)}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </TabPanel>
                                </TabPanels>
                        </Tabs>            
                        </div>
                        <div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
                            <div class="m-3">
                                <div class="pb-2 border-b border-lightgrey">
                                    <h1>Finding Details</h1>
                                </div>
                                <div v-if="tabDataLoading == true">
                                    <div class="flex items-center justify-center w-full h-16 skeleton">
                                    <dots-loader/>
                                    </div>
                                </div>
                                <div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
                                    <div class="flex flex-col">
                                        <label class="controllabel">Finding Status</label>
                                        <input disabled v-if="TaskDetailsDropDown.findingStatus == 10418" type="text" placeholder="Status" class="terminateBox inputboxstyling mt-2 mb-3" value="Terminated" />
                                        <!-- <select
                                            v-else
                                            class="mt-2 mb-3 custom-select w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                                            :class="changeBackground()"
                                            disabled
                                            v-model="TaskDetailsDropDown.findingStatus"
                                            @change="updateFindingStatus(TaskDetailsDropDown.findingStatus)"
                                        >
                                            <option value="" selected disabled hidden>Please select one</option>
                                            <option v-for="i in findingStatusData" :value="i.id" :key="i">
                                                {{ i.status }}
                                            </option>
                                        </select> -->
                                        <div v-else>
                                            <Select
                                                appendTo="body"
                                                v-model="TaskDetailsDropDown.findingStatus"
                                                :options="findingStatusData"
                                                optionLabel="status"
                                                optionValue="id"
                                                placeholder="Please select one"
                                                class="custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey"
                                                :class="changeBackground()"
                                                :disabled="true"
                                                @change="updateFindingStatus(TaskDetailsDropDown.findingStatus)"
                                            />

                                        </div>
                                    </div>
                                    
                                    
                                    <div>
                                        
                                        <div>
                                            <label class="controllabel">Assigned To</label>
                                            <div v-if="(newTeamAssignee.value != userInfo._id  && presentFindingObject.auditee == userInfo._id) || TaskDetailsDropDown.taskStatus == 10422|| TaskDetailsDropDown.taskStatus == 10422 || presentFindingObject.statusCode == 10403|| presentFindingObject.statusCode == 10418 || presentFindingObject.tasks != undefined">
                                                <p class="mt-2">{{ newTeamAssignee.label }}</p>
                                            </div>
                                            <div v-else>
                                                <!-- <multiselect
                                                    v-model="presentFindingObject.assignee"
                                                    :options="userOptions"
                                                    :showNoOptions="false"
                                                    @search-change="asyncFind"
                                                    :multiple="false"
                                                    :close-on-select="true"
                                                    :clear-on-select="true"
                                                    label="label"
                                                    open-direction="bottom"
                                                    :hide-selected="true"
                                                    track-by="value"   
                                                    @select="updateAssignedMember(presentFindingObject.assignee)" 
                                                    :searchable="true"
                                                    :hideArrow="false"
                                                    placeholder="Assigned-To"
                                                    deselectLabel=""
                                                    selectLabel=""
                                                    class="custom-multiselect userSelect mt-2"
                                                    :class="{
                                                        'has-options': userOptions && userOptions.length > 0,
                                                        'no-options': !userOptions.length &&  searchValue !== '',
                                                    }"
                                                >
                                                    <template v-slot:noResult>
                                                        <span class="text-xs">No Members Found</span>
                                                    </template>
                                                </multiselect> -->
                                                <AutoComplete
                                                    appendTo="body"
                                                    v-model="presentFindingObject.assignee"
                                                    :suggestions="userOptions"
                                                    placeholder="Assigned-To"
                                                    optionLabel="label"
                                                    field="label"
                                                    class="w-full custom-autocomplete userSelect mt-2"
                                                    @complete="asyncFind"
                                                    @item-select="updateAssignedMember(presentFindingObject.assignee)"
                                                    />

                                            </div>
                                            <!-- :disabled="TaskDetailsDropDown.taskStatus == 10403 || presentFindingObject.statusCode == 10403|| presentFindingObject.statusCode == 10418 || presentFindingObject.tasks != undefined || (presentFindingObject.auditor == userInfo._id) || (presentFindingObject.auditee != userInfo._id && presentFindingObject.assignee!= userInfo._id)" -->
                                            
                                        </div>
                                    </div> 
                                    <div class="mt-3">
                                        <label class="controllabel">Auditor</label><br>
                                        <div class="my-1 mt-2">{{ getPerson(presentFindingObject.auditor) }}</div>
                                    </div>
                                    <div class="mt-3">
                                        <label class="controllabel">Auditee</label><br>
                                        <div class="my-1 mt-2">{{ getAllPersonName(presentFindingObject.auditee) }}</div>
                                    </div>
                                    <div class="mt-3">
                                        <label class="controllabel">Team</label><br>
                                        <div class="my-1 mt-2">{{ getTeamName(presentFindingObject.department) }}</div>
                                    </div>
                                    <div class="mt-3">
                                        <label class="controllabel">Location</label><br>
                                        <div class="my-1">{{ getLocationName(presentFindingObject.department) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         </div>
                    </div>
                </div>
        </div>
         <popup v-if="showCausePopup" :popUp="showCausePopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Cause and Action</h1>
                    <button class="float-right text-3xl" @click="onCrossbtnForCauseAndAction()">
                        <img src="@/assets/cancel.svg" class="cursor-pointer" />
                    </button>
                 </div>
            </template>
              <div class='flex flex-col h-full'>
                <div class="flex-1 overflow-auto">
              <div class="formcontainer px-4 pb-4 flex flex-col">
                    <div class="flex-1 overflow-auto">
                    <div class="row flex flex-row mt-3">
                        <div class="w-full">
                        <label class="controllabel">Cause</label>
                        <input class="inputboxstyling mt-2" type="text" v-model.trim="causeActionObj.cause" placeholder="Cause for the Finding" :class="{'is-invalid': v$.causeActionObj.cause.$error }"/>
                        <div v-if="v$.causeActionObj.cause.$error" class="text-red-500">
                            <div class="error-text" v-if="v$.causeActionObj.cause.required.$invalid">Required</div>
                        </div>
                        </div>
                    </div>
                        <div class="flex justify-end items-center mt-2">
                            <button class="btnprimary" @click="addTextarea()">Add</button>
                        </div>
                        <label class="controllabel">Actions</label>
                        <div v-if="textareas.length == 0" class="text-red-500">
                            <div class="error-text" >Enter atleast one Action</div>
                        </div> 
                        <div class="mb-2" v-for="(textarea, index) in textareas" :key="index">
                            <!-- <div class="w-95 mr-5">
                            <textarea class="inputboxstyling mt-2" v-model.trim="textarea.action" placeholder="Add an action for this Cause" rows="3" :class="{'is-invalid borderRed': v$.textareas.$dirty && !v$.textareas.$each.$response.$data[index].action.required}"></textarea>
                                <div v-if="v$.textareas.$dirty && !v$.textareas.$each.$response.$data[index].action.required" class="text-red-500">		
                                    <div class="error-text" >Required</div>
                                    <div class="error-text" v-if="textareas.length == 0">atleast one Action is needed</div>
                                </div>
                                <div class="error-text" v-if="textareas.length == 0">atleast one Action is needed</div>           
                            </div>
                            <div class="w-5">
                            <div class="flex items-center justify-center h-full">
                                <img src="@/assets/deleteIcon.svg" class="cursor-pointer"  @click="clickedOnDeleteButton(index)"/> 
                            </div>
                            </div> -->
                            <div class="w-full flex flex-row">
                                <div class="w-95 mr-5">
                                <textarea
                                    class="inputboxstyling mt-2"
                                    v-model.trim="textarea.action"
                                    placeholder="Add an action for this Cause"
                                    rows="3"
                                    :class="{
                                    'is-invalid borderRed':
                                        v$.textareas.$dirty &&
                                        !v$.textareas.$each.$response.$data[index].action.required,
                                    }"
                                ></textarea>

                                <div
                                    v-if="
                                    v$.textareas.$dirty &&
                                    !v$.textareas.$each.$response.$data[index].action.required
                                    "
                                    class="text-red-500"
                                >
                                    <div class="error-text">Required</div>
                                </div>
                                </div>
                                <div class="w-5">
                                <div class="flex items-center justify-center h-full">
                                    <img
                                    src="@/assets/deleteIcon.svg"
                                    class="cursor-pointer"
                                    @click="clickedOnDeleteButton(index)"
                                    />
                                </div>
                                </div>
                            </div>
                            <div class="w-1/2 mt-3">
                                <label class="controllabel">Target Date</label>
                                <input
                                v-model="textarea.targetDate"
                                type="date"
                                class="mt-2 w-1/2"
                                @focus="openCalendar"
                                style="height:28px"
                                onkeydown="return false"
                                :max="todayDate"
                                :class="{
                                    'inputboxstylingForSelectAtPopup': textarea.targetDate == '',
                                    'stylingForInputboxstylingForSelectAtPopup': textarea.targetDate != '',
                                    'is-invalid borderRed':
                                    v$.textareas.$dirty &&
                                    v$.textareas.$each.$response.$data[index] &&
                                    v$.textareas.$each.$response.$data[index].targetDate &&
                                    !v$.textareas.$each.$response.$data[index].targetDate.required,
                                }"
                                />
                                <div
                                v-if="
                                    v$.textareas.$dirty &&
                                    v$.textareas.$each.$response.$data[index] &&
                                    v$.textareas.$each.$response.$data[index].targetDate &&
                                    !v$.textareas.$each.$response.$data[index].targetDate.required
                                "
                                class="text-red-500"
                                >
                                <div class="error-text">Target Date is Required</div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                </div>
                <div>
                    <div class="border-b border-solid border-lightgrey mx-5"></div>
                        <div v-if="!editVariable" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
                            <button class="btnprimary mr-2" :class=" (JSON.stringify(causeActionObj.cause) != JSON.stringify(causeActionObjDummy.cause)) || (JSON.stringify(textareas) != JSON.stringify(textareasDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelCauseAction()">Cancel</button>
                            <button class="btnprimary" :class="(JSON.stringify(causeActionObj.cause) != JSON.stringify(causeActionObjDummy.cause)) && (JSON.stringify(textareas) != JSON.stringify(textareasDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCauseAction()">Save</button>
                        </div>
                       
                        <div v-if="editVariable" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
                            <button class="btnprimary mr-2" :class=" (JSON.stringify(causeActionObj.cause) != JSON.stringify(objDummy.cause)) || (JSON.stringify(textareas) != JSON.stringify(causeActionObj.actions))  ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelEditedCauseAndAction()">Cancel</button>
                            <button class="btnprimary" :class="(JSON.stringify(causeActionObj.cause) != JSON.stringify(objDummy.cause)) || (JSON.stringify(textareas) != JSON.stringify(causeActionObj.actions)) && (textareas.length > 0)? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="updateCauseAndAction(causeIdOfCauseAndAction , createdAtForUpdate , createdByForUpdate)">Save</button>
                        </div>
                </div>
            </div>
        </popup>
        <popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
					<template v-slot:header>
						<div class="flex items-center justify-between m-4 rounded">
							<h1>Approval</h1>

							<button class="float-right text-3xl" @click="onCrossbtn()">
								<img src="@/assets/cancel.svg" class="cursor-pointer" />
							</button>
						</div>
					</template>

                    <div class='flex flex-col h-full'>
                        <div  class="flex-1 overflow-auto">
                            <div class="statuscontainer px-5 pb-5">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-row mt-3">
                                        <div class=" w-1/2">
                                            <label class="controllabel">Name of the Authority</label>
                                            <div class="inputboxstyling mt-2" disabled>{{getPersonName(presentFindingObject.auditor)}}</div>
                                        </div >
                                    </div>
                                    <div class="row flex flex-row mt-3">
                                        <div class="w-full">
                                            <label class="controllabel mt-2">Justification or Comments for Approving</label>
                                            <textarea
                                                class="inputboxstyling mt-2"
                                                placeholder="Comments"
                                                v-model.trim="taskObj.approvalComments"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="border-b border-solid border-lightgrey mx-5"></div>
                            <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                                <button class="btnprimary mr-2" :class="(taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary'" @click="onCancelbtnAtApproval()">Cancel</button>
                                <button class="btnprimary" :class="(taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary'" @click="applyAuthority()" :disabled="clickOnButtonForApproval">Save</button>
                            </div>
                        </div>
                    </div>
        </popup>
         <popup v-if="showRejectPopup">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Justification to Reject the Approval</h1>

          <button
            class="float-right text-3xl"
            @click="onCrossbtnToCloseRejectionPopup()"
          >
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
      <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
          <div class="statuscontainer px-5 py-5">
            <div class="formcontainer flex flex-col w-full">
              <label class="controllabel">Justification</label>
              <textarea
                class="inputboxstyling mt-2"
                placeholder="Comments"
                v-model.trim="rejectJustification.justification"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="border-b border-solid border-lightgrey mx-5"></div>
          <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                rejectJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnToReject()"
            >
              Cancel
            </button>
            <button
              class="btnprimary"
              :class="
                rejectJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="approveOrReject(10410)"
              :disabled="clickOnButtonForRejectingApproval"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </popup>

        
    </div>
</template>
<style scoped>
.terminateBox{
	background-color: #FF0000 !important;
	color: white;
	pointer-events: none;
}
.w-80{
	width: 80%;
}
.w-20{
	width:20%;
}
.widthForCommentBox{
	width : 75px;
}
.progress {
    background: #1976d2;
    position: relative;
    border-radius: 4px;
    z-index: 2;
}
.progressbarB {
    border: 2px solid #e9e9e9;
    background: #e9e9e9;
    position: relative;
    top: -8px;
    z-index: 1;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.primaryBackground{
    background-color: rgba(21, 42, 67, 0.23);
}
.paddingBottomForFindings{
    padding-bottom : 10.5px;
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}
.w-78{
    width : 78%;
}
.marginBottom1px{
    margin-bottom : 1px;
}
.descriptionToggle {
	height: 97%;
}
.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
.task-details-in-modal .descriptionToggle,
.task-details-in-modal .thirtyWidthToggle {
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-color: #a4a4a4 transparent;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar {
	width: 6px !important;
	height: 6px !important;
	display: block !important;
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-track,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-track {
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-thumb,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: #a4a4a4 !important;
	border-radius: 4px;
}
.tabStructure{
    height: calc(100vh - 165px);
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(25,118,210,0.24);
}
.custom-select {
     background-image: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
 
}
.inputboxstyling1 {
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgba(233, 233, 233, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}
 
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.labelWidth{
	min-width: 7rem;
}
.w-18{
   width : 18%
}
.w-82{
   width : 82%
}
.paddingBottomforApproval{
    padding-bottom : 7px
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import moment from 'moment';
import { emitter } from '@/main';
import popup from '@/components/popup.vue';
import Multiselect from 'vue-multiselect';
import { required, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { toast } from '@/main';
import commentsEditor from '@/components/commentsEditor.vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import safeHtml from "@/components/safeHtml.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import AutoComplete from 'primevue/autocomplete';
import Select from 'primevue/select';
export default defineComponent({
    props: {
        findingId: { type: [String, Number], default: null },
        modalMode: { type: Boolean, default: false },
    },
    emits: ['header-info', 'open-nested'],
    data(): any {
        return {
            selectedTabIndex: 1,
            selectedTabObj:{},
            tabHead: [
                { displayName: 'Finding Info', name: 'Findings Info' , id: 1 },
 
                { displayName: 'Cause&Action', name: 'Cause&Action', id: 2 },
 
                { displayName: 'Comments', name: 'Comments', id: 3 },

                { displayName: 'Approvals', name: 'Approvals', id: 4 },
 
                { displayName: 'History', name: 'History', id: 5 },
 
            ],
            findingCategoryData: [
				{
					id: 1,
					value: 'Minor'
				},
				{
					id: 2,
					value: 'Major'
				},
				{
					id: 3,
					value: 'OFI'
				},
				{
					id: 4,
					value: 'Observation'
				}
			],
            controlRiskSeverityLabelOptions: [],
            findingStatusData: [
				
			],
            tabDataLoading :false,
            locationObject:[],
            userOptions:[],
            personObj : '',
            oldComments: true,
            oldHistory : true,
            comment: '',
            comments: [],
            orgUsersList: [],
            allOrgUsers : [],
            optionsUserArray: [],
            assignedToList:[],
            btnDisabled: true,
            presentFindingObject : {},
            routesArray: [],
            users : [],
            showApprovalPopup: false,
            newTeamAssignee : '',
            showCausePopup : false,
            taskObj:{
                approvalComments : ''
            },
            // navIndexNums: { name: '', index: '' },
            approvingMembers:[],
            v$: useVuelidate(),
            causeActionObj: {
                cause: '',
                actions: [],
            },
            textareas: [{ action: '',targetDate:'' }] as { action: string ,targetDate: string}[],
            textareasDummy : [ { "action": "" ,targetDate:"" } ],
             textareasDummyForActions : [],
            causeActionObjDummy : [],
            causeAndActionSaved: false,
            validationErrors: [],
            causeActionTableData : {},
            statusCodeOfFinding : '',
            workLogObject: [],
            TaskDetailsDropDown: {
				findingStatus: '',
				assignee: ''
			},
            approvalObj : {},
            objDummy : {},
            editVariable : false,
            disableSendApprovalButton : false,
            textareaEditDummy :[],
            causeIdOfCauseAndAction : '',
            createdAtForUpdate : '' ,
            createdByForUpdate : '',
            causesLength : false,
            findingsTasksArray : [],
            finalFindingsTasks : [],
             showRejectPopup : false,
            rejectJustification:{
                justification : ''
            },
            clickOnButton:false,
            clickOnButtonForApproval:false,
            clickOnButtonForRejectingApproval:false,
            searchValue:'',
            dotsLoading:false
        }
    },
    validations() {
        return {
        causeActionObj: {
            cause: { required }
        },
        textareas: {
                $each: helpers.forEach({
                    action:{required},
                    targetDate: { required },
                })
            }
        };
    },
    computed: {
		...mapGetters({ userInfo: 'userInfo' ,dbFrequency: 'dbFrequency' , dbPriority:'dbPriority'}),
        currentFindingId(): any {
            return this.findingId || this.$route.params.findingId;
        },
        findingFileEvidences(): any[] {
            const files = this.presentFindingObject?.files;
            if (!Array.isArray(files)) return [];
            return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
        },
        findingLinkEvidences(): any[] {
            const files = this.presentFindingObject?.files;
            if (!Array.isArray(files)) return [];
            return files.filter((doc: any) => doc?.evidenceType === 'url');
        },
	},
    watch: {
        presentFindingObject: {
            handler(obj: any) {
                if (this.modalMode && obj && (obj.findingComment || obj.findingId)) {
                    this.$emit('header-info', { title: obj.findingComment || obj.findingId });
                }
            },
            deep: true,
        },
    },
    components:{
        breadCrumbs,
        popup,
        Multiselect,
        commentsEditor,
        safeHtml,
        dotsLoader,
        Tabs,
		Tab,
		TabList,
		TabPanels,
		TabPanel,
        AutoComplete,
        Select
    },
    methods :{
        showPopupToReject(){
          this.showRejectPopup = true;
        },
        openCalendar(event: any) {
            event.target.showPicker();
        },
        onCrossbtnToCloseRejectionPopup(){
            this.showRejectPopup = false;
            this.onCancelbtnToReject();
        },
        onCancelbtnToReject(){
          this.rejectJustification.justification = "";
        },
        extractInitials(name: any) {
            if(name!=undefined) {
                const names = name.split(' ');
			return names
				.map((name: any) => name[0])
				.join('')
				.toUpperCase();
            }
            else {
                return '';
            }
		},
        formatFileAttachedTime(time: any) {    
			let now = moment(time);
			return now.format("DD-MM-YYYY");
		},
        getS3KeyFromUrl(fileUrl: string) {
            try {
                const url = new URL(fileUrl);
                return url.pathname.startsWith('/')
                ? url.pathname.slice(1)
                : url.pathname;
            } catch (e) {
                return '';
            }
        },

        getEvidenceFileExt(doc: any) {
            if (!doc?.url || doc.evidenceType === 'url') return '';
            try {
                const path = new URL(doc.url).pathname;
                return (path.split('.').pop() || '').toLowerCase();
            } catch {
                return (String(doc.url).split('.').pop() || '').toLowerCase();
            }
        },
        async openEvidenceFile(doc: any) {
            const fileUrl = typeof doc === 'string' ? doc : doc?.url;
            if (!fileUrl) return;

            if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
                window.open(fileUrl, '_blank', 'noopener,noreferrer');
                return;
            }

            const key = this.getS3KeyFromUrl(fileUrl);
            if (!key) {
                return;
            }

            try {
                const response = await this.$http.post(
                `${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
                { key }
                );

                const signedUrl =
                typeof response.data === 'string'
                    ? response.data
                    : response.data?.url;

                if (signedUrl) {
                window.open(signedUrl, '_self');
                }
            } catch (err) {
                console.error(err);
            }
        },
        isAddDisabled(permission:any) {
			try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;
				}
				// if (this.userInfo.organisationType !== 10701) {
				// 	return true; 
				// }
				return this.hasPermission(this.userInfo, 10006, 10120, permission);
			} catch (e) {
				return true;
			}
	  	},
		hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
			if (!userInfo || !userInfo.apps) return false;
			const app = userInfo.apps.find((a:any) => a.appId === appId);
			if (!app) return false;

			const entity = app.entities?.find((e:any) => e.entityId === entityId);
			if (!entity) return false;

			return entity.permissions?.includes(permissionId) || false;
		},
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
        colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        getProirityLabel(val:any){    
            if (val === 'N/A') { 
                return ''; 
            } else {
                let a = this.dbPriority.find((obj: any) => obj.value == val);        
                return (val && typeof val === 'number') ? a.key : '';
            }
        },
         getPerson(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
        getTeamName(team: any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == team;
            });
            if (teamObj == undefined) {
                return '';
            } else {
                return teamObj.displayName;
            }
        },
        getLocationName(teamId: any) {
           let teamObj = this.users.find((obj: any) => {
                return obj._id == teamId;
            });
            if (teamObj == undefined) {
                return 'N/A';
            } else if(teamObj.entityType != undefined && teamObj.entityType == 20301) {
                return this.locationObject.find((l:any)=>l.entityType==1)?.label || 'N/A';
            }else if(teamObj.entityType != undefined && teamObj.entityType == 20303){
				return teamObj.entityDisplayName?teamObj.entityDisplayName:'N/A'
			}else{
				return 'N/A';
			}
        },
        getStatusLabel(num:any){
            let result = this.findingStatusData.find((obj:any)=>{return obj.id == num})
            if(result != null || result != undefined){
                return result.status
                
            }
		},
        async getFindingsStatuses(){
            let appId='10006';
            let entityId='10110';
            await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {
                this.findingStatusData = (result.data.statuses || []).map((item: any) => ({
                    id: item.id,
                    status: item.label
                }));
            });
        },
        asyncFind(query:any){
            query=query.query
            this.searchValue = '';
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.assignedToList.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        async updateFindingStatus(status: any) {
			let payload: any = { statusCode: status };
            
			await this.updatePresentFinding(payload,5);
		},
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updatePresentFinding(payload,4);
            if(this.presentFindingObject.assignee != undefined){
                this.newTeamAssignee = this.presentFindingObject.assignee
            }
		}, 
        async toggleTabs(obj: any) {
            this.tabDataLoading=true
            this.selectedTabIndex = obj.id;
            this.selectedTabObj = obj;
            // sessionStorage.setItem('selectedTab', obj.id);
            await this.getAllFindingsTasks()
            await this.getPresentFindingObject()
            await this.getFindingHistoryObject()
            this.tabDataLoading=false
        },
        sortComments() {
            this.oldComments = !this.oldComments;
            if(this.presentFindingObject.comments != undefined){
				this.presentFindingObject.comments.sort().reverse();
			}
        },
        
        sortHistory() {
            this.oldHistory = !this.oldHistory;
            if(this.workLogObject.findingHistory != undefined){
				this.workLogObject.findingHistory.sort().reverse();
			}
        },
        onCrossbtn(){
				this.showApprovalPopup = false;
				this.taskObj.approvalComments = '';
			
		},
        onCrossbtnForCauseAndAction(){
            this.showCausePopup = false;
            this.cancelCauseAction();
        },
        getCategory(num: any) {
            
			let result = this.findingCategoryData.find((obj: any) => {
				return obj.id == num;
			});
            return result.value
		},
        async loadFindingSeverityLabelOptions() {
            const valuesOf = (result: any) => {
                const values = result?.data?.[0]?.values;
                return Array.isArray(values) ? values : [];
            };
            try {
                const risk = await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/label/20420/getall`);
                this.controlRiskSeverityLabelOptions = valuesOf(risk).filter((item: any) =>
                    item && String(item.key).toUpperCase() !== 'N/A' && Number(item.value) !== 0
                );
            } catch (error) {
                this.controlRiskSeverityLabelOptions = [];
            }
        },
        getFindingSeverityValue(obj: any) {
            const raw = obj?.finding_severity ?? obj?.findingSeverity;
            if (raw == null || raw === '') return null;
            if (typeof raw === 'object') {
                const nested = raw.value != null && raw.value !== '' ? Number(raw.value) : NaN;
                return Number.isFinite(nested) && nested > 0 ? nested : null;
            }
            const numeric = Number(raw);
            return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
        },
        getFindingSeverityLabel(obj: any) {
            const raw = obj?.finding_severity ?? obj?.findingSeverity;
            if (raw == null || raw === '') return 'N/A';
            if (typeof raw === 'object' && raw.label != null && String(raw.label).trim() !== '') {
                return String(raw.label);
            }
            const value = this.getFindingSeverityValue(obj);
            const match = (this.controlRiskSeverityLabelOptions || []).find((item: any) => Number(item.value) === Number(value));
            return match?.key != null ? String(match.key) : 'N/A';
        },
        isDisabledFindingSeverityLabel(label: any) {
            const text = String(label || '').trim().toUpperCase();
            return text === 'N/A' || text === 'NONE';
        },
        findingSeverityChipBg(obj: any) {
            const label = this.getFindingSeverityLabel(obj);
            if (this.isDisabledFindingSeverityLabel(label)) {
                return ['bg-lightgrey border-solid border border-lightgrey'];
            }
            const value = this.getFindingSeverityValue(obj);
            return this.colorLabelBg(value) || ['bg-lightgrey border-solid border border-lightgrey'];
        },
        findingSeverityChipText(obj: any) {
            const label = this.getFindingSeverityLabel(obj);
            if (this.isDisabledFindingSeverityLabel(label)) {
                return ['text-gray text-xs font-semibold'];
            }
            const value = this.getFindingSeverityValue(obj);
            const textClass = this.colorLabelText(value);
            return textClass ? [...textClass, 'text-xs'] : ['text-gray text-xs font-semibold'];
        },
        onCancelbtnAtApproval(){
				this.taskObj.approvalComments = '';
		},
        openCausePopup(){
            this.editVariable = false
            this.showCausePopup = true;
        },
        openApprovalpopup(){
            this.showApprovalPopup = true;
        },
        clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
        formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
        getBorder(){
            return `numberBorder numberNavy`
        },
        handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
        changeBackground() {
			if (this.TaskDetailsDropDown.findingStatus == 10401) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.findingStatus == 10415 || this.TaskDetailsDropDown.findingStatus == 10421) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.findingStatus == 10402) {
				return 'bg-electricGreen textColorWhite';
			} else if (this.TaskDetailsDropDown.findingStatus == 10406) {
				return 'bg-primary textColorWhite';
			} else if (this.TaskDetailsDropDown.findingStatus == 10403 || this.TaskDetailsDropDown.findingStatus == 10422) {
				return 'bg-lightgreen textColorWhite';
			}else if (this.TaskDetailsDropDown.findingStatus == 10418) {
				return 'bg-veryHighColor textColorWhite';
			} else {
				return '';
			}
		},
        goToActionTasks(taskId:any){
            if (this.modalMode) {
                this.$emit('open-nested', {
                    view: 'findingTaskEdit',
                    title: 'CAPA Task',
                    params: { taskId: taskId, findingId: this.currentFindingId },
                });
            } else {
                this.$router.push({ name: 'findingTaskEdit', params: { taskId: taskId , findingId : this.currentFindingId } });
            }
        },
        checkAuditor(){
			if(this.presentFindingObject.auditor == this.userInfo._id || this.userInfo.role_id!=10216){
				return true
			} else if(this.presentFindingObject.auditor == undefined || this.presentFindingObject.auditor == null){
				return '-'
			} else {
				return false
			}
		},
        async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id,entityType:result[i].entityType });
            }
        },
        async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].teamName, value: this.users[i]._id });
            }
        },
        async getAllActiveUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
                this.orgUsersList = res.data;
                this.allOrgUsers = this.orgUsersList
                // this.orgUsersList = this.orgUsersList.filter((user: any) => {
                //     return user.isActive == true;
                // });
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    if(this.orgUsersList[i].roleId!=10217){
						this.assignedToList.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
                    
					// if(this.userInfo._id != this.orgUsersList[i]._id){
						this.approvingMembers.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					// }
                }
            });
        },
        
        async approveOrReject(statusCode : any){
            this.clickOnButtonForRejectingApproval = true;
            
            const payload: any = {
                statusCode:statusCode,
                rejectJustification:this.rejectJustification.justification,
                updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                updatedBy:this.userInfo._id
            };
           try{ 
            await this.$http
				.post(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/update/approval`,payload)
				.then((result: { data: any }) => {
                //    console.log('here it ISSSSSS',result.data)
                })
            if(statusCode == 10403 || statusCode==10422){
                toast.info(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
                const workflowpayload = [{findingId:this.currentFindingId,createdBy:this.userInfo._id,createdAt:moment().format('YYYY-MM-DD HH:mm:ss')}]
                await this.$http
                    .post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_AUDIT_WORKFLOW_ID}/audit/findings/task`,workflowpayload)
                    .then((result: { data: any }) => {
                        // console.log('here it ISSSSSS, the workflowpayload',result.data)
                    })
                   await this.getFindingHistoryObject()
            }else if(statusCode == 10410){
                toast.info(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
                await this.getFindingHistoryObject()
            }
             await this.getPresentFindingObject()
            this.onCrossbtnToCloseRejectionPopup()
            } catch (e) {
                toast.error(`Error`, {
                timeout: 1000,
                closeOnClick: true,
                closeButton: "button",
                icon: true,
                });
            } finally {
                 this.clickOnButtonForRejectingApproval = false;
			}
            // await this.getFindingHistoryObject()
        },
        async deleteCauseAndAction(causeId : any, cause : any){
            if(this.approvalObj.statusCode != 10403 && this.approvalObj.statusCode!=10422){
                const payload: any = {
                cause : cause,
                updatedBy: this.userInfo._id,
                updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            };

                await this.$http
				.post(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/cause/${causeId}/delete`,payload)
				.then(async (result: any) => {

                    await this.getPresentFindingObject()
                    await this.getFindingHistoryObject();
                })
            }
    },
    editCauseAndAction(obj:any){
        if(this.approvalObj.statusCode == 10403 || this.approvalObj.statusCode==10422){
            this.showCausePopup = false;
        }else{
        this.editVariable = true
        this.objDummy = {...obj}
        this.causeIdOfCauseAndAction = this.objDummy.causeId
        this.createdAtForUpdate = this.objDummy.createdAt
        this.createdByForUpdate = this.objDummy.createdBy
        delete this.objDummy.createdAt;
        delete this.objDummy.createdBy;
        delete this.objDummy.causeId;
        this.showCausePopup = true;
        let actions = this.objDummy.actions
        this.causeActionObj.cause = this.objDummy.cause;
        this.causeActionObj.actions = [...actions];
        this.textareaEditDummy = [...actions]
        this.textareas = [];
        this.objDummy.actions.map((obj:any)=>{this.textareas.push({...obj})})
        // this.textareaEditDummy = [...this.objDummy.actions]
        // this.causeActionObj.actions = this.objDummy.actions
        }
    },
    cancelEditedCauseAndAction(){
        this.causeActionObj.cause = this.objDummy.cause
        this.textareas = [];
        this.objDummy.actions.map((obj:any)=>{this.textareas.push({...obj})})
        this.v$.$reset();
        // this.textareas = this.objDummy.actions
    },
    async updateCauseAndAction(causeId : any , createdAt : any , createdBy : any){
        this.v$.$touch();
        let booleanValue = false;
        this.clickOnButton = true;
        if(this.textareas.length > 0){
            booleanValue = !this.textareas.some((obj: any) => obj.action === "");
            if (booleanValue) {
                this.causeActionObj.actions = [...this.textareas];
                const payload: any = {
                    cause : this.causeActionObj.cause,
                    actions: this.causeActionObj.actions,
                    createdBy:createdBy,
                    createdAt:createdAt,
                    updatedBy: this.userInfo._id,
                    updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                };
                try{
                    await this.$http
                    .post(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/cause/${causeId}/update`, payload)
                    .then(async (result: any) => {
                        toast.info(`Updated`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                        await this.getPresentFindingObject()
                        await this.getFindingHistoryObject();
                    })
                    // this.cancelEditedCauseAndAction()
                    this.showCausePopup = false;
                }catch (e) {
                  toast.error(`Error`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
                } finally {
                    this.clickOnButton = false;
                }
            }
        }
        // this.cancelEditedCauseAndAction()
    },
    async clickOnReject(){
        const payload: any = {
            statusCode:10410,
            updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            updatedBy:this.userInfo._id

        };
        await this.$http
            .post(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/update/approval`,payload)
            .then((result: { data: any }) => {
                // console.log('here it ISSSSSS',result.data)
            })
    },
        async applyAuthority() {
            this.showApprovalPopup = false;
            this.clickOnButtonForApproval = true;
            const payload: any = {
                approver: this.presentFindingObject.auditor,
                comments: this.taskObj.approvalComments,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                createdBy: this.userInfo._id
            };

            await this.updatePresentFinding(payload, 3);
            await this.getPresentFindingObject()
            this.taskObj.approvalComments = '';
       },
        async getFindingHistoryObject() {
			

			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/history/get`).then((result: any) => {
          
				const mainObject = result.data;
				this.workLogObject = mainObject;
			});
             if(this.workLogObject.findingHistory != undefined){
				this.workLogObject.findingHistory.sort().reverse();
			}
            
		},
        
        async addComment() {
			if (this.comment.trim() !== '') {
				const payload: any = {
					comment: this.comment,
                    createdAt: new Date(),
                    createdBy:this.userInfo._id
				};

                await this.updatePresentFinding(payload,2)
                if(this.presentFindingObject.comments != undefined){
                    this.presentFindingObject.comments.sort().reverse();
                }
                this.comment = ''
				this.btnDisabled = true;
			}
		},
		
        async getPresentFindingObject(){
        try{
            this.tabDataLoading = true
            await this.$http
				.get(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/get`)
				.then((result: any) => {
                    this.presentFindingObject = result.data[0];

                    if(this.presentFindingObject.causes==undefined|| this.presentFindingObject.causes.length == 0){
                        this.causesLength = true;
                    }else {
                        this.causesLength = false;
                    }

                    if (Array.isArray(this.presentFindingObject.approvals) && this.presentFindingObject.approvals.length > 0) {
                        const lastApproval = this.presentFindingObject.approvals[this.presentFindingObject.approvals.length - 1];
                        this.approvalObj = lastApproval;
                    }else{
                        this.approvalObj = {}
                    }
                });
                
                await this.getAllFindingsTasks()

                this.TaskDetailsDropDown.findingStatus = this.presentFindingObject.statusCode;

                if(this.presentFindingObject.assignee != undefined){
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentFindingObject.assignee});
					this.presentFindingObject.assignee = userObj;
				}else{
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentFindingObject.assignee});
					this.presentFindingObject.assignee = userObj;
				}
        } catch (error){
            toast.error(`Error`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: "button",
            icon: true,
            });
        } finally{
            this.tabDataLoading = false
        }
        },
        async getAllFindingsTasks(){
            await this.$http
				.get(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/capa-tasks/get`)
				.then((result: any) => {        
                    this.findingsTasksArray = result.data
                   this.finalFindingsTasks =  this.groupBy(this.findingsTasksArray,'cause');
                })
        },
        groupBy(arr: any, keyName: any) {
            return arr.reduce((group: any, product: any) => {
                const keyValue = product[keyName];
                group[keyValue] = group[keyValue] ?? [];
                group[keyValue].push(product);
                return group;
            }, {});
        },
        getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
        getAllPersonName(person: any) {
			let personObj = this.allOrgUsers.find((user: any) => {
              
				return user._id == person;
			});
			if (personObj == undefined) {
				return '';
			} else {
				return personObj.name;
			}
		},
        async saveCauseAction() {
            
            this.v$.$touch();
            if (!this.v$.causeActionObj.$invalid && !this.v$.textareas.$invalid) {
                this.clickOnButton = true;
                this.causeAndActionSaved = true;
                this.causeActionObj.actions = [...this.textareas];

               const payload: any = {
                    cause : this.causeActionObj.cause,
					actions: this.causeActionObj.actions,
                    createdAt:moment().format('YYYY-MM-DD HH:mm:ss'),
                    createdBy:this.userInfo._id
				};
                await this.updatePresentFinding(payload,1);
                this.onCrossbtnForCauseAndAction()     
            }
    },
    async updatePresentFinding(payload:any, type:any){
        
            payload.createdBy = this.userInfo._id;
            payload.createdAt = moment().format('YYYY-MM-DD HH:mm:ss');
			if(type == 1){
				payload.cause = payload.cause;
				// payload.additionalInfo.cause = payload.cause;
			}else if(type == 2){
				payload.comment = payload.comment;
				// payload.additionalInfo.comment = payload.comment;
			}else if(type == 3){
				payload.justification = payload.justification;
				// payload.additionalInfo.justification = payload.justification;
			}else if(type == 5){
				payload.previousStatus = this.presentFindingObject.statusCode;
                payload.updatedStatus = payload.statusCode;
				// payload.additionalInfo.previousStatus = this.presentFindingObject.statusCode;
				// payload.additionalInfo.updatedStatus = payload.statusCode;
			}else if(type == 4){
				payload.assignee = payload.assignee;
				// payload.additionalInfo.assignee = payload.assignee;
			}
            try {
				await this.$http
                .post(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/type/${type}/update`,payload)
                .then(async (result: any) => {
				
					toast.info(`Updated`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
                    if (type == 5) {
                        this.presentFindingObject.statusCode = payload.updatedStatus;
                    }else if(type == 4){
                        this.presentFindingObject.assignee = payload.assignee;
                 }
                    
					await this.getPresentFindingObject();
                    
                    await this.getFindingHistoryObject();
					
					
					
				});
			} catch {
				toast.error(`Error`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
			} finally {
                this.clickOnButton = false;
                this.clickOnButtonForApproval = false;
            }
            this.presentFindingObject.statusCode = payload.updatedStatus
    },
    colorFindingText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403 || status==10422) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold mx-2 text-electricGreen']
			} else if(status == 10406){
				return ['font-semibold mx-2 text-primary']
			}else if(status == 10417 || status == 10418){
				return ['font-semibold mx-2 text-darkred']
			}else if(status == 10408){
				return ['font-semibold mx-2 text-primary']
			}else if(status == 10419){
				return ['font-semibold mx-2 text-forReview']
			}
		},
		colorFindingBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403 || status==10422) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10406) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10417 || status == 10418) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}else if (status == 10408) {
				return ['evidenceUpload border-solid border border-primary'];
			} else if (status == 10419) {
				return ['bg-forReviewBg border-solid border border-forReview'];
			}
    },
    addTextarea() {
      this.v$.$reset();
      this.textareas.push({ action: '' ,targetDate:"" });
      
    },
    cancelCauseAction() {
        // this.causeAndActionSaved = false;
        this.causeObjectDummy = {...this.causeActionObj}
        this.v$.$reset();
        (this.causeActionObj.cause = ''),(this.causeActionObj.actions = [])
        this.textareas = [{ action: '',targetDate:""}]; 
        
    //   Reset to initial state with one textarea
    },
    clickedOnDeleteButton(index: number) {
      this.textareas.splice(index, 1);
    },
    },
    async mounted(){
		await this.loadFindingSeverityLabelOptions();
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
	},
    beforeUnmount() {
		 sessionStorage.removeItem('selectedTab')
	 },
    async created (){
        const savedTabKey = sessionStorage.getItem('selectedTab');
		if (savedTabKey) {
         const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
            if (savedTab) {
                this.toggleTabs(savedTab);
            }
            else{
               this.selectedTabObj = this.tabHead.find((tab:any) => tab.id === this.selectedTabIndex);
            }
        }else{
            this.selectedTabObj = this.tabHead.find((tab:any) => tab.id === this.selectedTabIndex);
        }
        this.dotsLoading=true
        this.tabDataLoading = true
        await this.getFindingsStatuses();
        await this.getAllActiveUsers();
        await this.getAllTeams();
        
        this.causeActionObjDummy = { ...this.causeActionObj };
        
        await this.getPresentFindingObject();

        await this.getFindingHistoryObject();
        
        this.auditorName = this.presentFindingObject.auditor
        
        await this.getallEntities();
       this.tabDataLoading = false
        this.routesArray = [
            { name: 'My Findings', routeName: 'myFindings' },
			{ name: this.presentFindingObject.findingId, routeName: 'myFindings' }
        ];

        if(this.presentFindingObject.comments != undefined){
            this.presentFindingObject.comments.sort().reverse();
        }

        if(this.presentFindingObject.assignee != undefined){
            this.newTeamAssignee = this.presentFindingObject.assignee
        }
        this.dotsLoading=false
        // this.routesArray = [
		// 	{ name: this.presentFindingObject.findingId, routeName: 'myFindings' },
        // ];
        // this.navIndexNums = { index: 1, name: 'Finding Info' };
    },
   
})
</script>